import { Route, Routes } from "react-router-dom"
import { Materials } from "../pages/materials"

export const MainRoutes = () => {
    return (
        <Routes>
            <Route path="materials" element={<Materials />} />
            <Route path="activities" element={<h1>Activities</h1>} />
        </Routes>
    )
}
